// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.copy-right-modal {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.85);
  z-index: 9999;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
}
.copy-right-modal .modal-container {
  font-family: "Proxima Nova", sans-serif;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(129, 159, 188, 0.15);
  border-radius: 25px;
  width: 60vw;
  padding: 30px;
  height: 70vh;
  overflow: hidden;
}
.copy-right-modal .modal-container ::-webkit-scrollbar {
  width: 5px;
  opacity: 0;
}
.copy-right-modal .modal-container:hover {
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.copy-right-modal .modal-container:hover ::-webkit-scrollbar {
  opacity: 1;
}
.copy-right-modal .modal-container:hover ::-webkit-scrollbar-track {
  border-radius: 10px;
}
.copy-right-modal .modal-container:hover ::-webkit-scrollbar-thumb {
  background: #b4b4b4;
  border-radius: 10px;
}
.copy-right-modal .modal-container:hover ::-webkit-scrollbar-thumb:hover {
  background: #b4b4b4;
}
.copy-right-modal .modal-container .modal-title {
  display: flex;
  justify-content: center;
  font-weight: 700;
  font-size: 24px;
  color: var(--secondary-color-1);
  position: relative;
  justify-content: space-between;
}
.copy-right-modal .modal-container .modal-title .close {
  cursor: pointer;
}
.copy-right-modal .modal-container .modal-title .close:hover {
  opacity: 0.75;
}
.copy-right-modal .modal-container .content {
  height: 100%;
  overflow-y: auto;
}
.copy-right-modal .modal-container .content > section {
  font-family: "Proxima Nova", sans-serif;
}
.copy-right-modal .modal-container .content > section > p, .copy-right-modal .modal-container .content > section h1, .copy-right-modal .modal-container .content > section h2 {
  margin: 0;
  width: -moz-fit-content;
  width: fit-content;
}
.copy-right-modal .modal-container .content > section > h1 {
  font-weight: 700;
  font-size: 40px;
}
.copy-right-modal .modal-container .content > section ol.list {
  list-style: upper-alpha;
}
.copy-right-modal .modal-container .content > section ol.list.lower-alpha {
  list-style: lower-alpha;
}
.copy-right-modal .modal-container .content > section ol.list > li {
  margin-left: 20px;
  margin-bottom: 30px;
}
.copy-right-modal .modal-container .content > section ol.list > li::marker {
  font-weight: 700;
  font-size: 16px;
  color: var(--secondary-color-1);
}
.copy-right-modal .modal-container .content > section ol.list > li > p {
  padding-left: 30px;
}
.copy-right-modal .modal-container .content > section .body {
  line-height: 30px;
  font-weight: 400;
  font-size: 16px;
  color: var(--secondary-color-1);
}
.copy-right-modal .modal-container .content > section .body.underlined {
  text-decoration-line: underline;
  text-decoration-color: var(--secondary-color-2);
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.copy-right-modal .modal-container .content > section .body.underlined:hover {
  opacity: 0.75;
}
.copy-right-modal .modal-container .content > section .header {
  font-weight: 700;
  font-size: 16px;
  color: var(--secondary-color-1);
}
.copy-right-modal .modal-container .content > section .numerals {
  margin-left: 35px;
  position: relative;
  margin-top: 30px;
}
.copy-right-modal .modal-container .content > section .numerals::after {
  content: attr(data-list);
  position: absolute;
  font-weight: 700;
  left: -35px;
  top: 0;
}
.copy-right-modal .modal-container .content > section .numerals ul.list {
  list-style: disc;
}
.copy-right-modal .modal-container .content > section .numerals ul.list > li {
  margin-left: 20px;
  margin-top: 20px;
}
.copy-right-modal .modal-container .content > section .numerals ul.list > li::marker {
  font-weight: 700;
  font-size: 16px;
  color: var(--secondary-color-1);
}
.copy-right-modal .modal-container .content > section .numerals ul.list > li > p {
  margin: 0;
  display: inline-block;
}
.copy-right-modal .modal-container .content > section .link {
  color: var(--primary-color-1);
}
.copy-right-modal .modal-container .content > section .link.cursor {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/routes/DisclosurePages/modules/CopyRightModal/copyRightModal.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,2CAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AAAI;EACI,uCAAA;EACA,mBAAA;EACA,kDAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAER;AADQ;EACI,UAAA;EACA,UAAA;AAGZ;AADQ;EAII,UAAA;EAIA,WAAA;EAKA,oBAAA;AAPZ;AALY;EACI,UAAA;AAOhB;AAJY;EACI,mBAAA;AAMhB;AAHY;EACI,mBAAA;EACA,mBAAA;AAKhB;AAFY;EACI,mBAAA;AAIhB;AADQ;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,8BAAA;AAGZ;AAFY;EACI,eAAA;AAIhB;AAHgB;EACI,aAAA;AAKpB;AADQ;EACI,YAAA;EACA,gBAAA;AAGZ;AAFY;EACI,uCAAA;AAIhB;AAHgB;EACI,SAAA;EACA,uBAAA;EAAA,kBAAA;AAKpB;AAHgB;EACI,gBAAA;EACA,eAAA;AAKpB;AAHgB;EACI,uBAAA;AAKpB;AAJoB;EACI,uBAAA;AAMxB;AAJoB;EACI,iBAAA;EACA,mBAAA;AAMxB;AALwB;EACI,gBAAA;EACA,eAAA;EACA,+BAAA;AAO5B;AALwB;EACI,kBAAA;AAO5B;AAHgB;EACI,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AAKpB;AAJoB;EACI,+BAAA;EACA,+CAAA;EACA,eAAA;EACA,4BAAA;AAMxB;AALwB;EACI,aAAA;AAO5B;AAHgB;EACI,gBAAA;EACA,eAAA;EACA,+BAAA;AAKpB;AAHgB;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;AAKpB;AAJoB;EACI,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,MAAA;AAMxB;AAJoB;EACI,gBAAA;AAMxB;AALwB;EACI,iBAAA;EACA,gBAAA;AAO5B;AAN4B;EACI,gBAAA;EACA,eAAA;EACA,+BAAA;AAQhC;AAN4B;EACI,SAAA;EACA,qBAAA;AAQhC;AAHgB;EACI,6BAAA;AAKpB;AAJoB;EACI,eAAA;AAMxB","sourcesContent":[".copy-right-modal {\n    width: 100%;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    background-color: rgba($color: white, $alpha: .85);\n    z-index: 9999;\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .modal-container {\n        font-family: 'Proxima Nova', sans-serif;\n        background: #FFFFFF;\n        box-shadow: 0px 4px 20px rgba(129, 159, 188, 0.15);\n        border-radius: 25px;\n        width: 60vw;\n        padding: 30px;\n        height: 70vh;\n        overflow: hidden;\n        ::-webkit-scrollbar {\n            width: 5px;\n            opacity: 0;\n        }\n        &:hover {\n            ::-webkit-scrollbar {\n                opacity: 1;\n            }\n            /* Track */\n            ::-webkit-scrollbar-track {\n                border-radius: 10px;\n            }\n            /* Handle */\n            ::-webkit-scrollbar-thumb {\n                background: #b4b4b4; \n                border-radius: 10px;\n            }\n            /* Handle on hover */\n            ::-webkit-scrollbar-thumb:hover {\n                background: #b4b4b4; \n            }\n        }\n        .modal-title {\n            display: flex;\n            justify-content: center;\n            font-weight: 700;\n            font-size: 24px;\n            color: var(--secondary-color-1);\n            position: relative;\n            justify-content: space-between;\n            .close {\n                cursor: pointer;\n                &:hover {\n                    opacity: .75;\n                }\n            }\n        }\n        .content {\n            height: 100%;\n            overflow-y: auto;\n            > section {\n                font-family: 'Proxima Nova', sans-serif;\n                > p, h1, h2 {\n                    margin: 0;\n                    width: fit-content;\n                }\n                > h1 {\n                    font-weight: 700;\n                    font-size: 40px;\n                }\n                ol.list {\n                    list-style: upper-alpha;\n                    &.lower-alpha {\n                        list-style: lower-alpha;\n                    }\n                    > li {\n                        margin-left: 20px;\n                        margin-bottom: 30px;\n                        &::marker {\n                            font-weight: 700;\n                            font-size: 16px;\n                            color: var(--secondary-color-1);\n                        }\n                        > p {\n                            padding-left: 30px;\n                        }\n                    }\n                }\n                .body {\n                    line-height: 30px;\n                    font-weight: 400;\n                    font-size: 16px;\n                    color: var(--secondary-color-1);\n                    &.underlined {\n                        text-decoration-line: underline;\n                        text-decoration-color: var(--secondary-color-2);\n                        cursor: pointer;\n                        transition: .2s ease-in-out;\n                        &:hover {\n                            opacity: .75;\n                        }\n                    }\n                }\n                .header {\n                    font-weight: 700;\n                    font-size: 16px;\n                    color: var(--secondary-color-1);\n                }\n                .numerals {\n                    margin-left: 35px;\n                    position: relative;\n                    margin-top: 30px;\n                    &::after {\n                        content: attr(data-list);\n                        position: absolute;\n                        font-weight: 700;\n                        left: -35px;\n                        top: 0;\n                    }\n                    ul.list {\n                        list-style: disc;\n                        > li {\n                            margin-left: 20px;\n                            margin-top: 20px;\n                            &::marker {\n                                font-weight: 700;\n                                font-size: 16px;\n                                color: var(--secondary-color-1);\n                            }\n                            > p {\n                                margin: 0;\n                                display: inline-block;\n                            }\n                        }\n                    }\n                }\n                .link {\n                    color: var(--primary-color-1);\n                    &.cursor {\n                        cursor: pointer;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
